module.exports = __webpack_public_path__ + "img/animals_rabbit.6e564c82.png";